import React, { useEffect } from "react";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import Do from "./Components/Do/Do";
import Home from "./Components/Home/Home";
import Navbar from "./Components/Navbar/Navbar";
import ProductList from "./Components/product/ProductList";
import Work from "./Components/Work/Work";
// import Projects from './Components/Projects/Projects'
import Lenis from "lenis";

function Main() {
  const lenis = new Lenis();
  useEffect(() => {
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);
  return (
    <div className="App">
      <div className="main relative flex flex-col gap-2">
        <Navbar />
        <Home />
        <Work />
        <About />
        <Contact />
      </div>
    </div>
  );
}

export default Main;
